import { useNodeId } from "@xyflow/react";
import { ColorPicker } from "../../ColorPicker";
import { NodeToolbarTop } from "../NodeToolbarTop";
import styles from "./FloatingColorPicker.module.css";

type Props = {
  color: string;
};

export function FloatingColorPicker({ color }: Props) {
  const id = useNodeId();

  if (!id) {
    return null;
  }

  return (
    <NodeToolbarTop>
      <fieldset className={styles.fieldset}>
        <ColorPicker id={id} color={color} showHexInput={true} />
      </fieldset>
    </NodeToolbarTop>
  );
}
